// src/api/authAPI.js - Enhanced with charger context support (preserving existing functionality)
import apiClient from './client';

const AUTH_URL = '/api/v1/auth';

// Enhanced login function with optional charger context
export const login = async (email, password, chargerName = null, connectorNumber = null) => {
  try {
    const requestData = {
      email,
      password
    };

    // Add charger parameters if provided (NEW for QR code login)
    if (chargerName && connectorNumber) {
      requestData.charger_name = chargerName;
      requestData.connector_number = connectorNumber;
    }

    const response = await apiClient.post(`${AUTH_URL}/login`, requestData);
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Get current user information from token
export const getCurrentUser = async () => {
  try {
    const response = await apiClient.get(`${AUTH_URL}/me`);
    return response.data;
  } catch (error) {
    console.error('Get current user error:', error);
    throw error;
  }
};

// Logout user
export const logout = async () => {
  try {
    const response = await apiClient.post(`${AUTH_URL}/logout`);
    return response.data;
  } catch (error) {
    console.error('Logout error:', error);
    throw error;
  }
};

// Create new user (Admin or SuperAdmin)
export const createUser = async (userData) => {
  try {
    const response = await apiClient.post(`${AUTH_URL}/create-user`, userData);
    return response.data;
  } catch (error) {
    console.error('Create user error:', error);
    throw error;
  }
};

// Get all users (SuperAdmin only)
export const getAllUsers = async () => {
  try {
    const response = await apiClient.get(`${AUTH_URL}/users`);
    return response.data;
  } catch (error) {
    console.error('Get all users error:', error);
    throw error;
  }
};

// Helper function to check if user has required role
export const hasRole = (userRole, requiredRole) => {
  const roleHierarchy = {
    'SuperAdmin': 3,
    'Admin': 2,
    'Driver': 1
  };
  
  return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
};

// Helper function to check if user can access company data
export const canAccessCompany = (user, companyId) => {
  // SuperAdmin can access all companies
  if (user.role === 'SuperAdmin') {
    return true;
  }
  
  // Admin and Driver can only access their own company
  return user.company_id === companyId;
};

// // NEW: Helper function to build charger details URL from charger context
// export const buildChargerDetailsUrl = (chargerContext) => {
//   if (!chargerContext) return null;
  
//   return `/chargers/${chargerContext.charger_id}?company=${chargerContext.company_id}&site=${chargerContext.site_id}`;
// };

export const buildChargerDetailsUrl = (chargerContext) => {
  if (!chargerContext) return null;
  
  const { charger_id, company_id, site_id, connector_number } = chargerContext;
  
  // Build the new driver page URL with query parameters
  const params = new URLSearchParams({
    charger_id: charger_id,
    company: company_id,
    site: site_id,
    connector: connector_number
  });
  
  return `/chargers-driver-page?${params.toString()}`;
};